<template>
  <div>
    <div id="pContent">
      <div id="conList">
        <div id="wTable">
          <div id="tab1">活动名称</div>
          <div id="tab2">活动时间</div>
        </div>
        <div id="oneCon" v-for="(item, index) in tableData" :key="index">
          <div id="navdht"><img src="../../assets/img/navdh.png"></div>
          <div>
            <div class="text">
              <router-link tag="span" :to="{path:'/Social/flowmuseumDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">{{ item.title }}</router-link>&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="item.wState===1">
                <span v-if="item.yycount === item.countnum">
                  <el-button size="mini" round type="warning">人数已满</el-button>
                </span>
                <span v-else>
                  <router-link tag="el-button" :to="{path:'/about/sjactivity/activitybm', query:{id:item.id,title:item.title}}"
                    class="btn" type="success">预约报名</router-link>
                </span>
              </span>
              <span v-if="item.wState===2">
                <el-button size="mini" round type="warning">进行中</el-button>
              </span>
              <span v-if="item.wState===0">
                <el-button size="mini" round type="info">已结束</el-button>
              </span>
            </div>
            <div><span>{{ item.starttime }}</span>&nbsp;至&nbsp;<span>{{ item.endtime }}</span></div>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin: 2rem 0;text-align:right">
      </el-pagination>
    </div>
    <div id="mpContent">
      <div id="mconList">
        <div id="mwTable">
          <div id="mtab1">活动名称</div>
        </div>
        <div id="moneCon" v-for="(item, index) in marrData" :key="index">
          <div>
            <div class="text" style="text-align: left;">
              <router-link tag="span" :to="{path:'/Social/flowmuseumDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}"><img
                  style="width: 15px;height: 15px;" src="../../assets/img/mnavdh.png"><span style="margin-left: 5px;">{{ item.title }}</span></router-link>&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="item.wState==1">
                <span v-if="item.yycount === item.countnum">
                  <el-button size="mini" round type="warning">人数已满</el-button>{{item.yycount}}
                </span>
                <span v-else>
                  <router-link tag="el-button" :to="{path:'/about/sjactivity/activitybm', query:{id:item.id,title:item.title}}"
                    class="btn" type="success">预约报名</router-link>
                </span>
              </span>
              <span v-if="item.wState==2">
                <el-button size="mini" round type="warning">进行中</el-button>
              </span>
              <span v-if="item.wState==0">
                <el-button size="mini" round type="info">已结束</el-button>
              </span>
            </div>
            <div><span style="margin-left: 20px;">时间：</span><span>{{ item.starttime }}</span>&nbsp;至&nbsp;<span>{{ item.endtime }}</span></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <el-pagination background @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="currentPage"
          :page-sizes="[10]" layout="total, prev, pager, next" :total="pageTotal.total" style="margin-top: 1em;text-align:right">
        </el-pagination>
      </div>
    </div>
  </div>

</template>

<script>
  import moment from 'moment'
  import qs from 'qs'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
        mtableData: [],
        marrData: []
      }
    },
    mounted() {

      if (this.isMobile()) {
        document.getElementById("mpContent").style.display = "block";
        document.getElementById("pContent").style.display = "none";
        this.mhandleSearch();
      } else {
        document.getElementById("mpContent").style.display = "none";
        document.getElementById("pContent").style.display = "block";
        this.handleSearch();
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.msearch();
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        this.search();
      },
      mhandleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("mconList").style.height = eWidth * 0.4 + "px";
        this.msearch();
        this.mlensearch();
      },
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/activity/activity?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list
          for (let i = 0; i < that.tableData.length; i++) {
            let timestampEnd = parseInt(that.tableData[i].activityendtime);
            let timestampstart = parseInt(that.tableData[i].activitytime);
            that.tableData[i].endtime = moment(timestampEnd).format("YYYY-MM-DD");
            that.tableData[i].starttime = moment(timestampstart).format("YYYY-MM-DD");
            var newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            let nowdate = moment(newtime, 'YYYY-MM-DD HH:mm').valueOf();
            if (nowdate < timestampstart) {
              that.tableData[i].wState = 1;
            } else if (nowdate >= timestampstart && nowdate <= timestampEnd) {
              that.tableData[i].wState = 2;
            } else if (nowdate > timestampEnd) {
              that.tableData[i].wState = 0;
            };
            let urls = that.HOST + '/api/v1/activity/activityRg?pageNumber=' + that.pageNum + '&pageSize=' + that
              .pageSize +
              '&id=' + that.tableData[i].id + '';
            that.$axios.get(urls).then(function(result) {
              that.tableData[i].yycount = result.data.data.total;
            }).catch(function(erroe) {
              that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
              });
            })
          };
          that.lensearch();
        }).catch(function(error) {
          console.log(err);
        })
      },
      lensearch: function() {
        let that = this;
        this.loading = true;
        for (let i = 0; i < this.tableData.length; i++) {
          let url = this.HOST + '/api/v1/activity/activityRgCount/' + this.tableData[i].id + '';
          this.$axios.get(url).then(function(results) {
            let pData = results.data;
            let urls = that.HOST + '/api/v1/activity/activityNum/' + that.tableData[i].id + '/' + pData.data.count +
              '';
            that.$axios.put(urls).then(function(result) {
              that.loading = false;
            }).catch(function(erroe) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
              });
            })
          }).catch(function(error) {
            console.log(error)
          });
        }
      },
      // mobile查询列表
      msearch: function() {
        let that = this;
        let url = this.HOST + '/api/v1/activity/activity?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          that.marrData = [];
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.mtableData = cData.data.list;
          for (let i = 0; i < that.mtableData.length; i++) {
            let timestampEnd = parseInt(that.mtableData[i].activityendtime);
            let timestampstart = parseInt(that.mtableData[i].activitytime);
            let str = {};
            str.id = that.mtableData[i].id;
            if (that.mtableData[i].title.length > 12) {
              str.title = (that.mtableData[i].title).substring(0, 12) + "...";
            } else {
              str.title = that.mtableData[i].title;
            };
            str.endtime = moment(timestampEnd).format("YYYY-MM-DD");
            str.starttime = moment(timestampstart).format("YYYY-MM-DD");
            var newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            let nowdate = moment(newtime, 'YYYY-MM-DD HH:mm').valueOf();
            if (nowdate < timestampstart) {
              str.wState = 1;
            } else if (nowdate >= timestampstart && nowdate <= timestampEnd) {
              str.wState = 2;
            } else if (nowdate > timestampEnd) {
              str.wState = 0;
            };
            that.marrData.push(str);
          }
          that.mlensearch();
        }).catch(function(error) {
          console.log(err);
        })
      },
      mlensearch: function() {
        let that = this;
        this.loading = true;
        for (let i = 0; i < this.mtableData.length; i++) {
          let url = this.HOST + '/api/v1/activity/activityRgCount/' + that.mtableData[i].id + '';
          this.$axios.get(url).then(function(results) {
            let pData = results.data;
            if (pData && pData.data) {
              let par = {
                id: that.mtableData[i].id,
                num: pData.data.length
              }
              let urls = that.HOST + '/api/v1/activity/activityNum/' + that.mtableData[i].id + '/' + pData.data.count +
                '';
              that.$axios.put(urls).then(function(result) {
                that.loading = false;
              }).catch(function(erroe) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: '请求出现异常',
                  duration: 2000
                });
              })
            }
          }).catch(function(error) {
            console.log(error)
          });
        }
      }
    }
  }
</script>

<style scoped>
  #pContent {
    display: none;
  }

  #wTable {
    height: 60px;
    position: relative;
    background: #DEDEDE;
    margin-top: 25px;
  }

  #tab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50px;
    font-weight: 500;
  }

  .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
    border-radius: 20px;
    padding: 7px 15px;
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;
  }

  #tab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 0;
    font-weight: 500;
    margin-right: 160px;
  }

  #navdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }

  #navdht>img {
    width: 100%;
    height: 100%;
  }

  #oneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    margin-left: 40px;
    margin-right: 40px;
  }

  #oneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 50px;
  }

  #oneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 0;
    cursor: pointer;
  }

  #oneCon>div>.text {
    cursor: pointer;
  }

  #oneCon>div>.text:hover,
  #oneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }

  /*mobile*/
  #mconList {
    margin: auto 20px;
  }

  #mwTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
  }

  #mtab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 10%;
    font-weight: 500;
  }

  #moneCon {
    height: 80px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
  }

  #moneCon>div>div:nth-child(1) {
    line-height: 40px;
    font-size: 1em;
  }

  #moneCon>div>div:nth-child(2) {
    line-height: 40px;
    font-size: 1em;
    text-align: left;
  }

  #moneCon>div>.text {
    cursor: pointer;
  }

  #moneCon>div>.text:hover,
  #moneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Social/flowmuseum.vue